module.exports = __webpack_public_path__ + "media/images/talent/mv-slider03-0f81c5b45d7cdadbbe1d1ed9967bfa82.png";